import { Anchor, Menu } from "@mantine/core"
import { IconDotsVertical } from "@tabler/icons-react"
import type { ReactNode } from "react"

import { queryClient } from "~/backend/queryClient"
import { findAdminOrganizationSuppliersKey } from "~/gen/api/hooks"
import type { UpdateUserRequestDtoPreferedLangageIso6391EnumKey } from "~/gen/api/types/UpdateUserRequestDto.ts"

export type UserOptionsUser = {
  readonly id: string
  readonly email: string
  readonly name: string
  readonly active: boolean
  readonly locale: UpdateUserRequestDtoPreferedLangageIso6391EnumKey
  readonly hasMutedReminders?: boolean
}

export const USER_OPTIONS_NOTIFICATIONS = {
  ANONYMIZE_SUCCESS: {
    message: `User anonymized`,
  },
  ANONYMIZE_ERROR: {
    title: "Error",
    message: "An error occurred while anonymizing the user",
  },
} as const

export const invalidateOrganizationQueries = (organizationId: string): void => {
  queryClient.invalidateQueries({
    queryKey: ["organizations", organizationId],
  })
  queryClient.invalidateQueries({
    queryKey: findAdminOrganizationSuppliersKey(organizationId),
  })
}

type UserOptionsMenuProps = {
  readonly userName: string
  readonly children: ReactNode
}

export const UserOptionsMenu = ({
  userName,
  children,
}: UserOptionsMenuProps) => {
  return (
    <Menu>
      <Menu.Target>
        <Anchor
          component="button"
          type="button"
          aria-label={`Options for ${userName}`}
          data-testid="user-options-menu"
        >
          <IconDotsVertical size={16} />
        </Anchor>
      </Menu.Target>
      <Menu.Dropdown>{children}</Menu.Dropdown>
    </Menu>
  )
}
